const DOWNLOAD_LINK = 'https://app.adjust.com/sdr8jjh'
const PLAY_DOWNLOAD_LINK = 'https://play.google.com/store/apps/details?id=de.getsafe.nxt&gl=DE'

export const downloadButtonConfiguration = {
  elementType: 'a',
  href: DOWNLOAD_LINK,
  target: '_blank',
  rel: 'noopener noreferrer',
} as const

export const downloadPlayButtonConfiguration = {
  elementType: 'a',
  href: PLAY_DOWNLOAD_LINK,
  target: '_blank',
  rel: 'noopener noreferrer',
} as const
